import React from 'react';

export const DEFAULT_CONTEXT = {
  isFormattingVisible: false,
};

const FormatterContext = React.createContext(DEFAULT_CONTEXT);
export default FormatterContext;
